module.exports = __webpack_public_path__ + "static/media/amex-active.832de825.svg";